import i18next from 'i18next';
import i18nextHttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
i18next.use(i18nextHttpBackend).use(initReactI18next).init({
    lng: 'en',
    fallbackLng: 'en',
    debug: false,
    saveMissing: true,
    backend: {
        loadPath: '/assets/public/locales/{{lng}}/translation.json'
    },
    interpolation: {
        escapeValue: false
    }
});
export default i18next;
